import { sharedRoutes } from './SharedRoutes'
import { instructorRoutes } from './InstructorRoutes'
import { adminRoutes } from './AdminRoutes'
import { student911Routes } from './Student911Routes'
import { student12Routes } from './Student12Routes'
import { parentRoutes } from './ParentRoutes'

export const routes = [...sharedRoutes, ...instructorRoutes, ...adminRoutes, ...student911Routes, ...student12Routes, ...parentRoutes]
